// 配置环境参数：生产环境
export default function () {
  return {
    alphaOrigin: 'https://realestate.ilawhegui.cn',
    shenceServerUrl: 'https://shence.alphalawyer.cn/sa?project=production',
    shenceWebUl: 'https://shenceadmin.alphalawyer.cn?project=production',
    shenceShowlog: false,
  };
}
